import builder from '../builder';
import MultipleManWoman1 from '../../streamline-icons/bold/multiple-man-woman-1.svg';

export default builder('IconMultipleManWoman1Bold', MultipleManWoman1);
